@app.directive 'csFetchActivityShortcode', ->
  restrict: 'E'
  scope: {}
  controllerAs: 'csFetchActivityShortcode'
  bindToController:
    'slug': '@'
  controller: (ActivityService, $state, $element) ->
    $element.parent().addClass('has-recipe-card')
    @isLoaded = false
    activityRequest = ActivityService.get id: @slug
    activityRequest.$promise
      .then (result) =>
        @result = result
        @isLoaded = true
    this
  templateUrl: "/assets/templates/directives/shortcodeOutputs/csFetchActivityShortcode/csFetchActivityShortcode.html"
